import { render, staticRenderFns } from "./EmptyImage.vue?vue&type=template&id=1c1fa5b4&scoped=true&"
import script from "./EmptyImage.vue?vue&type=script&lang=js&"
export * from "./EmptyImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1fa5b4",
  null
  
)

export default component.exports